import { utils } from 'ethers'

import { formatTicks } from './string.helpers'

export const formatToUSD = (number, isValueNegative = false) => {
  if (isValueNegative) {
    return `-$${number}`
  }
  return `$${number}`
}

export const formatToDecimals = (n, m) => n.toFixed(m)

export const formatCurrencyValue = (value, maxDigits = 2) => {
  return value ? parseFloat(formatToDecimals(parseFloat(value), maxDigits)) : ''
}

export function formatNumber(number = 0) {
  let value = number.toString()
  if (value.toUpperCase().indexOf('E') > -1) {
    // number is in scientific notation
    value = toFixed(value)
  }

  if (value.indexOf('.') > -1) {
    value = value.slice(0, value.indexOf('.'))
  }

  return utils.formatEther(value)
}

// converts scientific notation number to string
function toFixed(num) {
  let x = num
  if (Math.abs(x) < 1.0) {
    const e = parseInt(x.toString().split('e-')[1], 10)
    if (e) {
      x *= 10 ** (e - 1)
      x = `0.${new Array(e).join('0')}${x.toString().substring(2)}`
    }
  } else {
    let e = parseInt(x.toString().split('+')[1], 10)
    if (e > 20) {
      e -= 20
      x /= 10 ** e
      x += new Array(e + 1).join('0')
    }
  }
  return x
}

export function isValidNumber(number) {
  if (number) {
    const noCommaNumber = number.split(',').join('.')
    return noCommaNumber.length > 0 && !Number.isNaN(Number(noCommaNumber))
  }

  return false
}

export const displayCurrencyValue = (number) => {
  const value = formatCurrencyValue(number) || 0
  const isValueNegative = Math.sign(value) === -1
  return value !== undefined
    ? formatToUSD(
        formatTicks(isValueNegative ? Math.abs(value) : value),
        isValueNegative
      )
    : ''
}

export const percentageOfCompletion = (current, total) => {
  const completed = (current / total) * 100
  return Math.ceil(completed > 100 ? 100 : completed)
}

export const formatPercentage = (n) => n * 100

export const ceilNumber = (n) => Math.ceil(n)
export const floorNumber = (n) => Math.floor(n)

export const addNumbers = (n1, n2) => n1 + n2
